import React from "react";
import "./Education.scss";
import { EditOutlined } from "@ant-design/icons";
import { TUserSectionProp } from "@utils/Interfaces";
import { Empty, Skeleton } from "antd";

const Education: React.FC<TUserSectionProp> = ({
  setIsEditProfileVisible,
  setActiveTab,
  userProfile,
  loading,
}) => {
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const month = ("0" + (date.getMonth() + 1)).slice(-2); // Adding 1 because getMonth() is zero-based
    const year = date.getFullYear();

    return `${month}/${year}`;
  };

  return (
    <div className="card card-profile education">
      <div
        className="edit-action"
        onClick={() => {
          setIsEditProfileVisible(true);
          setActiveTab("5");
        }}
      >
        <EditOutlined />
      </div>
      <div className="card-title">Education</div>
      <div className="edu-description">
        <div className="d-flex flex-column gap-2">
          {!loading ? (
            <Skeleton active />
          ) : userProfile.education?.length == 0 ||
            userProfile.education == null ? (
            <Empty />
          ) : (
            userProfile.education.map((item: any, index) => {
              return (
                <div className="edu-item" key={index}>
                  <div className="edu-time">
                    {formatDate(item.start_date)} - {formatDate(item.end_date)}:{" "}
                    {item.name} at{" "}
                    {item.address}
                  </div>
                  <li className="edu-des">
                    {item.description}
                  </li>
                </div>
              );
            })
          )}
        </div>
      </div>
    </div>
  );
};

export default Education;
